import React from "react";
import "../../assets/css/seller-dashboard.css";
import "../../assets/css/seller-refund-details.css";
import "../../assets/css/seller-order-details.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Seller_sidebar from "./Seller-sidebar/Seller_sidebar";
import Seller_tabs_list from "./Seller-sidebar/Seller_tabs_list";
import { orderimg1, return_pic } from "../../constants";
import SellerHeader from "../../components/SellerHeader/SellerHeader";
import SellerFooter from "../../components/SellerFooter/SellerFooter";

const Seller_refund_detail = () => {
	return (
		<>
			{/* Header starts here */}
			<SellerHeader />
			{/* Header ends here */}
			<section className="dashboard">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<Seller_sidebar />
						</div>
						<div className="col-lg-8">
							<Seller_tabs_list />

							<div
								className="return-detail-wrapper"
								style={{ paddingTop: "0px" }}
							>
								<div className="order-return-wrapper">
									<div className="order-id-wrapper">
										<span>Order #12345 was placed on 29 October 2022</span>
									</div>
									<div className="return-details-wrapper">
										<h5>Refund Detail</h5>
									</div>
									<div className="retun-pro-headi-wrapper">
										<h5>Return Product</h5>
									</div>
									<div className="product-refund-wrapper">
										<div className="img-wrapper">
											<figure>
												<img src={orderimg1} className="img-fluid" alt="" />
											</figure>
										</div>
										<div className="refund-content-wrapper">
											<div className="head-date-wrapper">
												<h5>Sweet Black Shirt </h5>
												<h6>Purchase Date</h6>
											</div>
											<div className="size-wrapper">
												<div className="size-ql-wrapper">
													<ul>
														<li>Size L</li>
														<li>Quantity 2</li>
													</ul>
												</div>
												<div className="size-date-wrapper">
													<span>10/11/22</span>
												</div>
											</div>
											<div className="price-wrapper">
												<h5>RS : $22.00</h5>
											</div>
										</div>
									</div>
									<div className="return-reason-wrapper">
										<div className="reason-heading-wrapper">
											<h5>Return Reason</h5>
										</div>
										<input
											type="text"
											className="form-control"
											placeholder="This product is not mine"
										/>
									</div>
									<div className="return-picctures-wrapper">
										<div className="pictures-head-wrapper">
											<h5>Return Products Pictures</h5>
										</div>
										<div className="pictures-wrapper">
											<img src={return_pic} className="img-fluid" alt="" />
											<img src={return_pic} className="img-fluid" alt="" />
											<img src={return_pic} className="img-fluid" alt="" />
										</div>
									</div>
									<div className="comment-head-wrapper">
										<h5>Comment</h5>
									</div>
									<div className="comment-wrapper">
										<p>
											Lorem ipsum dolor sit amet, consectetur adipiscing elit,
											sed do eiusmod tempor incididunt ut labore et dolore magna
											aliqua. Ut enim ad minim veniam, quis nostrud exercitation
											ullamco laboris nisi ut aliquip ex ea commodo consequat.
										</p>
									</div>
									<div className="app-btns-wrapper">
										<a href="/seller-reject-refund" className="btn">
											Reject
										</a>
										<a href="/seller-accept-refund" className="btn">
											Accept
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Footer starts here */}
			<SellerFooter />
			{/* Footer ends here */}
		</>
	);
};

export default Seller_refund_detail;
